import React from 'react';
import './Accomplishments.css'
const Accomplishments = () => (
// container to hold background color 
    <div className='accomplishments-container'> 
    {/* Main Heading for accomplish element */}
        <h1 className='accomplishments-heading1'>Accomplishments</h1>
{/* robotics heading  */}
        <h2 className='accomplishments-heading2'>FRC Robotics</h2> 
       {/* p1 element for the robotics section  */}
                        <p1 className='roboticsp1'> 
                        FRC Team 4329: Lutheran Roboteers <br/> 
                        Time: 2021-2024 <br/> 
                        Leadership: Mechanical Crew Lead <br/> 
                        -Helped the team reach the FRC Einstein Tournament in 2023, <br/> 
                        and place 5th overall that year in the world
                        </p1>






    </div>
);
export default Accomplishments 
